export function todayISO(): string {
  // toLocaleDateString('sv-SE') даёт 'YYYY-MM-DD' в локальной таймзоне.
  return new Date().toLocaleDateString('sv-SE');
}

/** Локальный календарный день для ISO datetime; null при невалидной дате. */
export function localDateISOFrom(isoDateTime: string): string | null {
  const d = new Date(isoDateTime);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('sv-SE');
}

/** Запись аудита строго позже дня среза (сравнение календарных дней, не timestamp). */
export function isAfterSnapshotDay(recordIso: string, snapshotDay: string): boolean {
  const recordDay = localDateISOFrom(recordIso);
  if (!recordDay) return false;
  return recordDay > snapshotDay;
}

export function formatDateRu(date: Date): string {
  return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;
}
